<template>
  <div>
    <div class="header-video">
      <img :src="loadUrl.vps_img" />
      <div class="video-text">
        <div class="logo-text">
          <span>混空VPS</span>
        </div>
        <div class="link-room">混空VPS（Visual Positioning System）由公司自主研发，是一款融合多源数据和AI视觉算法，提供高精度定位和环境感知，帮助开发者快速部署XR沉浸式体验的定位系统。</div>
        <a class="experience-now" href="https://vps.njyjxr.com">
          <span>立即体验</span>
          <div class="experience-btn"></div>
        </a>
      </div>
    </div>
    <div class="boot-first">
      <div class="title deep">为你构建室内外稳定的<span style="color: #822EFF;">空间计算能力</span></div>
      <main>
        <div class="item" v-for="item in modelTypes[MODEL]" :key="item.header">
          <img :src="item.image" alt="">
          <div class="content">
            <h3>{{ item.header }}</h3>
            <ul>
              <li v-for="remark in item.remarkList" :key="remark">{{ remark }}</li>
            </ul>
          </div>
        </div>
      </main>
    </div>
    <div class="wmdys">
      <div class="title">我们的优势</div>
      <div class="wmdys-content">
        <div class="left">
          <header>
            <img src="@/assets/images/ar-images/icon/cbys-icon2.png" class="l-iamge" alt="">
            <div class="r-head">成本优势</div>
          </header>
          <div class="line">· 技术使用成本低；</div>
          <div class="line">· 云SAAS化服务降低使用门槛。</div>
        </div>
        <div class="right" style="padding-right: 50rem;box-sizing: border-box;">
          <header>
            <img src="@/assets/images/ar-images/icon/cjys-icon2.png" class="l-iamge" alt="">
            <div class="r-head">场景优势</div>
          </header>
          <div class="line">· 现实空间三维建图、复杂环境感知、视觉导航上优势显著；</div>
          <div class="line">· 在城市级别大空间和复杂环境定位上优势显著，如商业广场、博物馆、历史遗迹等；</div>
          <div class="line">· 在机器人、自动驾驶、医疗、消费电子等领域具备可拓展前景。</div>
        </div>
      </div>
    </div>
    <div class="yycj">
      <div class="title deep">应用场景</div>
      <div class="scene-list-box">
        <div class="type-list">
          <div v-for="item in sceneTypeList" :key="item">{{ item }}</div>
        </div>
        <div class="scene-list">
          <img src="@/assets/images/ar-images/icon/yycj-vps1.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps2.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps3.png" />
          <img src="@/assets/images/ar-images/icon/yycj-vps4.png" />
        </div>
      </div>
    </div>
    <example-introduction mode-class="pop-style-light" title-class="title" :exampleData="exampleDatas.kjsj"></example-introduction>
    <div class="package">
      <div class="title deep">按需选择 灵活购买</div>
      <div class="title-tips deep">混空VPS产品体系</div>
      <div class="package-list">
        <div>
          <div>有并发要求</div>
          <div class="suv-title2">标准服务包含</div>
          <div class="service-content">
            <div>
              <span>定位面积</span>
              <span>定位服务时长</span>
              <span>并发数量</span>
              <span>技术支持</span>
            </div>
          </div>
          <div class="contact-btn" @click="toContact()">立即咨询</div>
          <div class="contact-tips">可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>
        </div>
        <div>
          <div>无并发要求</div>
          <div class="suv-title2">标准服务包含</div>
          <div class="service-content">
            <div>
              <span>定位面积</span>
              <span>定位服务时长</span>
              <span>技术支持</span>
            </div>
          </div>
          <div class="contact-btn" @click="toContact()">立即咨询</div>
          <div class="contact-tips">可根据您的项目实际情况，购买标准服务(支持按需扩展单项)</div>
        </div>
      </div>
    </div>
    <contact-us v-if="store.state.contactUsTop"></contact-us>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import ContactUs from '@/components/ContactUs2.vue'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
import store from '@/store';
import { modelTypes } from '@/config';
import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import { exampleDatas } from '@/config/index'

const MODEL = 'vision_ar_vps'
const loadUrl: any = ref({})
const sceneTypeList = ['工业设计', '教育培训', '文博场馆', '城市规划', '停车场', '景区公园', '体育赛事', '商业街区', '历史遗迹', '演唱会', '科技馆', '旅游导览', '活动晚会', '娱乐体验', '大型会展', '智慧工厂']

let timer: any = null;

const toContact = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 565 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

onMounted(async () => {
  const vps_img: any = await asynchronousRetrieval('webimg/images/vps-img.png');
  loadUrl.value = { vps_img }
})

onUnmounted(() => {
  clearInterval(timer)
})
</script>
<style scoped lang="less">
.title {
  font-weight: 600;
  font-size: 61rem;
  color: #FFFFFF;

  &.deep {
    color: #000;
  }
}

.title-tips {
  font-weight: 500;
  font-size: 32rem;
  color: #FFFFFF;
  margin-top: 24rem;
  margin-bottom: 47rem;

  &.deep {
    color: #000;
  }
}

.header-video {
  position: relative;
  width: 100%;
  height: 44.79vw;
  position: relative;
  background-size: 100% 100%;
  background: linear-gradient(180deg, #b240f9 0%, #6602c8 100%);

  img {
    width: 32.92vw;
    height: auto;
    object-fit: fill;
    position: absolute;
    right: 10.78vw;
    top: 8.33vw;
  }

  .video-text {
    width: 58.33vw;
    position: absolute;
    top: 14.73958vw;
    left: 50%;
    margin-left: -29.167vw;
    font-size: 1.0417vw;
    color: #FFFFFF;
    text-align: left;

    .logo-text {
      font-weight: 600;
      font-size: 4.167vw;
      color: #FFFFFF;
    }

    .link-room {
      font-size: 1.4vw;
      color: #FFFFFF;
      margin-top: 1.0417vw;
      width: 37.45vw;
      line-height: 2;
    }

    .experience-now {
      width: 9.479vw;
      height: 3.3854vw;
      background: #fff;
      border-radius: 1.71875vw;
      margin-top: 4.55vw;
      padding: 0 0.36458vw 0 1.25vw;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      color: #7E06FF;
      font-weight: bold;

      .experience-btn {
        width: 2.604vw;
        height: 2.604vw;
        background: url(~@/assets/images/next-icon3.png);
        background-size: 100% 100%;
      }
    }
  }
}

.wmdys {
  width: 100%;
  height: 600rem;
  background-image: url(~@/assets/images/ar-images/aurora-bg.png);
  background-size: 100% 100%;
  padding: 96rem 0 0 0;
  box-sizing: border-box;

  .wmdys-content {
    display: flex;
    justify-content: center;
    align-items: center;

    .left {
      margin-right: 16rem;
    }

    .left,
    .right {
      width: 552rem;
      height: 246rem;
      border-radius: 12rem;
      overflow: hidden;
      background: url('@/assets/images/ar-images/youshiback2.png') no-repeat;
      background-size: 100% 100%;
      margin-top: 65rem;

      header {
        display: flex;
        align-items: center;
        margin: 42rem 0 16rem 0;
        box-sizing: border-box;
        padding-left: 42rem;


        .l-iamge {
          width: 56rem;
          height: 54rem;
          margin-right: 24rem;
        }

        .r-head {
          font-weight: 500;
          font-size: 20rem;
          color: #414141;
        }
      }

      .line {
        font-size: 14rem;
        color: #5C5C5C;
        line-height: 24rem;
        text-align: left;
        box-sizing: border-box;
        padding-left: 42rem;
      }
    }
  }
}

.yycj {
  background-color: #EFEFEF;
  height: 965rem;
  padding-top: 96rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .scene-list-box {
    width: 1120rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 65rem;

    &>div {
      height: 609rem;
    }

    &>div:first-child {
      position: relative;
      top: -14rem;
      width: 286rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 24px;
      color: #4F4F4F;

      &>div:nth-child(2n) {
        margin-left: 28rem;
      }

      &>div {
        width: 128rem;
        height: 52rem;
        line-height: 52rem;
        background: rgba(255,255,255,0.64);
        border-radius: 4rem;
        text-align: center;
        margin: 14rem 0;
      }
    }

    .scene-list {
      width: 810rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      top: -12rem;

      &>img {
        width: 396rem;
        height: 294rem;
        background-color: #fff;
        margin: 12rem 0;
        border-radius: 4rem;
      }

      &>img:nth-child(2n) {
        margin-left: 16rem;
      }
    }
  }
}

.boot-first {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  // width: 100vw;
  height: 743rem;
  background: #E1E5FF;

  .title {
    margin-bottom: 46rem;
    margin-top: 95rem;
  }

  main {
    display: flex;

    .item {
      width: 268rem;
      height: 393rem;
      background: #FFFFFF;
      border-radius: 12rem;
      margin-right: 16rem;

      img {
        width: 268rem;
        height: 157rem;
      }

      .content {
        box-sizing: border-box;
        padding: 20rem 24rem 0;

        h3 {
          font-weight: 500;
          font-size: 20rem;
          color: #333333;
          margin-bottom: 20rem;
          text-align: left;
          box-sizing: border-box;
          padding-left: 1rem;
          margin-top: 0;
        }


        ul {
          padding-left: 20rem;

          li {
            font-size: 14rem;
            color: #5C5C5C;
            text-align: left;
            line-height: 24rem;
            // text-align: justify;
          }
        }
      }
    }
  }
}

.package {
  height: 842rem;
  background: linear-gradient(180deg, #FFFFFF 0%, #E9EFF6 100%);
  padding-top: 112rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .package-list {
    width: 1132rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 27rem;

    &>div {
      position: relative;
      width: 548rem;
      height: 390rem;
      background: rgba(255,255,255,0.32);
      box-shadow: 0px 4rem 20rem 0px rgba(0,0,0,0.06);
      border-radius: 24rem;
      border: 1px solid rgba(0,0,0,0.1);
      padding: 36rem 36rem 54rem;
      box-sizing: border-box;

      &:hover {
        border: 1px solid #702EFF;
      }

      &>div:first-child {
        font-weight: 600;
        font-size: 32rem;
        color: #000000;
        text-align: left;
        margin-bottom: 32rem;
      }

      .suv-title2 {
        font-weight: 600;
        font-size: 20rem;
        color: #000000;
        text-align: left;
        margin-bottom: 16rem;
      }

      .service-content {
        text-align: left;
        margin-bottom: 16rem;

        span {
          display: inline-block;
          font-weight: 400;
          font-size: 16rem;
          color: rgba(112, 46, 255, 1);
          text-align: center;
          padding: 6rem 12rem;
          background: rgba(112, 46, 255, 0.10);
          border-radius: 4rem;
          margin-right: 11rem;
          margin-bottom: 16rem;
        }
      }

      .function-box {
        font-weight: 400;
        font-size: 16rem;
        color: #4F4F4F;
        text-align: left;

        &>div {
          position: relative;
          margin-bottom: 12rem;
          padding-left: 22rem;

          &::before {
            content: '';
            width: 16rem;
            height: 16rem;
            background-image: url(~@/assets/images/studio/list-iconA.png);
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 4rem;
          }
        }
      }

      .contact-btn {
        width: 476rem;
        height: 80rem;
        line-height: 80rem;
        background: rgba(112, 46, 255, 1);
        border-radius: 8rem;
        font-weight: 500;
        font-size: 24rem;
        color: #FFFFFF;
        position: absolute;
        bottom: 90rem;
        left: 36rem;
        cursor: pointer;
      }

      .contact-tips {
        font-weight: 400;
        font-size: 16px;
        color: #828282;
        position: absolute;
        bottom: 50rem;
        left: 0;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>